export const frTranslations = {
  errorBoundary: {
    title: 'Oups, une erreur est survenue',
    message: "Un problème inattendu s'est produit. Vous pouvez réessayer.",
  },
  api: {
    'ContactRequest.AlreadyExists':
      'Vous avez déjà envoyé une demande de contact à cet utilisateur',
    'Global.OperationNotAllowedError': "Vous n'êtes pas autorisé à effectuer cette opération",
    'Global.ResourceDeletionNotAllowedError':
      "Vous n'êtes pas autorisé à supprimer cette ressource",
    'Global.ResourceNotFoundError': "La ressource n'a pas été trouvée",
    'IdentityAndAccess.InvalidCredentialsError': "L'email ou le mot de passe n'est pas bon",
    'IdentityAndAccess.EmailAlreadyTakenError': "L'email est déjà pris",
    'Networking.CannotCancelNonPendingContactRequestError':
      "Vous ne pouvez pas annuler une demande de contact qui n'est pas en attente",
    'Networking.OnboardingAlreadyCompleteError':
      "Vous avez déjà complété le processus d'onboarding",
    'Networking.GhostProfileNoEmailError':
      "Ce profil n'a pas d'adresse e-mail. Ajoutez une adresse e-mail pour envoyer une invitation.",
    'Notifications.DeviceAlreadyRegisteredError': 'Le device est déjà enregistré',
    NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion internet.',
  },
  tabNavigation: {
    home: 'Accueil',
    contacts: 'Contacts',
    messages: 'Messages',
    notifications: 'Notifications',
    chatbot: 'Assistant IA',
    profile: 'Menu',
  },
  chatbot: {
    title: 'Assistant IA',
    placeholder: 'Posez-moi une question...',
    thinking: 'Réflexion en cours...',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    welcome:
      'Bonjour ! Je suis votre assistant IA. Je peux vous aider à gérer vos contacts, notes, catégories et hashtags. Comment puis-je vous aider ?',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    actionConfirmed: 'Action confirmée.',
    actionCancelled: 'Action annulée.',
    suggestionsTitle: 'Voici quelques exemples :',
    suggestions: {
      notes: 'Cherche dans toutes mes notes',
      conversations: 'Résume ma dernière conversation LinkedIn',
      sector: 'Qui travaille dans la cybersécurité ?',
      calendar: 'Quels sont mes prochains rendez-vous ?',
      birthdays: 'Quels anniversaires arrivent bientôt ?',
      findContact: 'Aide-moi à retrouver un contact',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'Un seul contact peut changer toute une vie.',
    connection: 'Connexion',
    registration: 'Inscription',
    slogan: 'Gardez, gérez vos contacts de demain \n Trouvez et réalisez des projets communs',
  },
  login: {
    title: 'Se connecter',
    email: 'Adresse mail',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    button: 'Connexion',
    noAccount: "Je n'ai pas de compte",
    or: 'Ou',
    error: {
      noInfo: 'Entrer vos informations',
      wrongCredentials: "L'email ou le mot de passe n'est pas bon",
    },
  },
  register: {
    title: "S'inscrire",
    email: 'Adresse mail',
    password: 'Mot de passe',
    confirmPassword: 'De nouveau mot de passe',
    button: 'Inscription',
    haveAccount: "J'ai déjà un compte",
    or: 'Ou',
    error: {
      noInfo: 'Entrer vos informations',
      notSamePassword: 'Les mots de passe ne correspondent pas',
    },
  },
  registerSteps: {
    step2: 'Tu es plutôt ? #',
    step3: 'Le meilleur moment pour te contacter ?',
    skip: 'Passer',
  },
  registerStep1: {
    title: {
      picture: 'Ajoute ta photo de profil :',
      gender: 'Tu es :',
      name: 'Ton prénom :',
      surname: 'Ton nom :',
      birthday: "Ta date d'anniversaire :",
      athletic: 'Est ce que tu es sportif :',
      info: 'A propos de toi :',
      languages: 'Quelles langues parles-tu :',
      nationality: 'De quelle nationalité es-tu :',
      origin: 'Quelle origine as-tu :',
      personality: 'Quel est ton caractère :',
      residence: 'Où habites-tu :',
      smoker: 'Est-ce que tu fumes :',
      conditions: "J'accepte les conditions",
    },
    value: {
      women: 'Une femme',
      man: 'Un homme',
      nonBinary: 'Non binaire',
      other: 'Autre',
      yes: 'Oui',
      no: 'Non',
      calm: 'Calme',
      active: 'Actif',
      talkative: 'Bavard',
    },
    next: 'Suivant',
  },
  registerStepHastags: {
    mainTitle: 'Ce qui te définit #',
    title: 'Quels sont les hashtags qui te correspondent',
    placeholder: '#sport',
    next: 'Suivant',
  },
  registerStep3: {
    mainTitle: 'Le meilleur moment pour te contacter ?',
    title: 'Sélectionne les moments où tu es le plus disponible',
    aperitif: 'Apéro',
    breakfast: 'Petit déj',
    coffee: 'Café',
    dinner: 'Dîner',
    lunch: 'Déjeuner',
    walk: 'Balade',
    video_call: 'Vidéoconf',
    phone_call: 'Téléphone',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Événement',
    next: 'Suivant',
  },
  registerStep4: {
    aperitif: 'Apéro',
    breakfast: 'Petit déj',
    coffee: 'Café',
    dinner: 'Dîner',
    lunch: 'Déjeuner',
    walk: 'Balade',
    videoCall: 'Vidéoconf',
    phoneCall: 'Téléphone',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Événement',
    next: 'Suivant',
  },
  registerFinalStep: {
    congrats: 'Félicitations,\n{name} {surname},\n ton compte est créé',
    next: 'Suivant',
    geolocationText: 'Activer la géolocalisation pour une meilleure expérience utilisateur',
  },
  forgotPassword: {
    title: 'Réinitialiser mot de passe',
    email: 'Adresse mail',
    emailConfirm: 'Confirmer adresse mail',
    button: 'Envoyer un lien par mail',
    success:
      'Si un compte existe avec cette adresse mail, vous recevrez un lien de réinitialisation sous peu.',
    error: {
      noEmail: 'Veuillez entrer votre adresse mail.',
      generic: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    },
  },
  resetPassword: {
    title: 'Définir un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    button: 'Réinitialiser le mot de passe',
    success: 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.',
    error: {
      noToken: 'Lien de réinitialisation invalide ou manquant. Veuillez en demander un nouveau.',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordMismatch: 'Les mots de passe ne correspondent pas.',
      generic: 'Le lien a peut-être expiré. Veuillez en demander un nouveau.',
    },
  },
  contact: {
    title: 'Contacts',
    searchPlaceholder: 'Rechercher un contact',
    commonContacts: '{nbr} contacts{newline} en commun',
    commonProjects: '{nbr} projets{newline} en commun',
    addButton: 'Ajouter',
    addTitle: 'Ajouter {name} à votre profil',
    commonTitleModal: 'Amis et projets en commun',
    filter: {
      search: 'Rechercher',
      category: {
        location: 'Lieux',
        origin: 'Origine',
        role: 'Fonction',
        degree: 'Degré',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Rechercher un pays',
        region: 'États / Region',
      },
      nonLocation: {
        origin: 'Rechercher une origine',
        role: 'Rechercher une fonction',
        hashtag: 'Rechercher par #',
      },
    },
    emptyReceivedRequest: 'Aucune demande reçue pour le moment',
    emptySentRequest: 'Aucune demande envoyée pour le moment',
    emptyContactPro: 'Aucun contact professionnel',
    emptyContactPrivate: 'Aucun contact privé',
  },
  addContact: {
    title: 'Rechercher un contact',
    commonContacts: '{nbr} contacts{newline} en commun',
    commonProjects: '{nbr} projets{newline} en commun',
    addButton: 'Ajouter',
    addTitle: 'Ajouter {name} à votre profil',
    commonTitleModal: 'Amis et projets en commun',
    filter: {
      search: 'Rechercher',
      category: {
        location: 'Lieux',
        origin: 'Origine',
        role: 'Fonction',
        degree: 'Degré',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Rechercher un pays',
        region: 'États / Region',
      },
      nonLocation: {
        origin: 'Rechercher une origine',
        role: 'Rechercher une fonction',
        hashtag: 'Rechercher par #',
      },
    },
    emptyData: 'Aucun contact suggéré',
    degree1: '1er',
    degree2: '2e',
    degree3: '3e',
  },
  requestContact: {
    received: 'Reçues',
    sended: 'Envoyées',
  },
  menu: {
    profileButton: 'Voir le profil',
    nonExistentProfile: 'Profil non existant',
    share: 'Partager',
    settings: 'Paramètres',
    signOut: 'Se déconnecter',
    version: 'Version {version}',
  },
  contactType: {
    PRIVATE: 'Privé',
    PROFESSIONAL: 'Pro',
    GROUP: 'Groupe',
    OTHERS: 'Autres',
    GHOST: 'Fantôme',
  },
  profile: {
    premiumTitle: 'Essayez Premium',
    mainMenus: {
      updateProfile: 'Modifier le profil',
      shareProfile: 'Partager le profil',
      calendar: 'Calendrier',
      memories: 'Souvenirs',
    },
    hashtags: {
      blocTitle: 'Compétences',
      learn: {
        title: 'Apprendre',
        placeholder: 'Rechercher tes objectifs...',
      },
      target: {
        title: 'Objectifs',
        placeholder: 'Construire une maison...',
      },
      hobby: {
        title: 'Loisirs',
        placeholder: 'Faire du karaté...',
      },
      skill: {
        title: 'Compétences',
        placeholder: 'Marketing...',
      },
      button: 'Sauvegarder',
    },
    contact: {
      email: {
        title: 'Email',
      },
      phoneNumber: {
        title: 'Numéro de téléphone',
      },
      website: {
        title: 'Site web',
      },
      fbProfile: {
        title: 'Profil Facebook',
      },
      instagramProfile: {
        title: 'Profil Instagram',
      },
      linkedinProfile: {
        title: 'Profil LinkedIn',
      },
      twitterProfile: {
        title: 'Profil Twitter',
      },
      availability: 'Disponibilités',
      contact: 'Coordonnées',
    },
    presentation: {
      title: 'Présentation',
    },
    question: {
      title: 'Question',
      button: 'Sauvegarder',
      nationalities: {
        title: 'Quelles sont tes nationalités :',
        placeholder: 'Rechercher une nationalité...',
      },
      origins: {
        title: 'Quelles sont tes origines :',
        placeholder: 'Rechercher une origine...',
      },
      languages: {
        title: 'Quelles langues parles-tu :',
        placeholder: 'Rechercher une langue...',
        modal: {
          title: 'Sélectionner un pays',
          search: {
            placeholder: 'Rechercher un pays...',
          },
        },
      },
      countries: {
        title: 'Quels pays as-tu visités :',
        placeholder: 'Rechercher un pays...',
      },
      addLanguage: {
        title: 'Ajouter une langue',
        button: 'Sauvegarder',
        language: {
          title: 'Langue',
          placeholder: 'Sélectionner une langue',
        },
        level: {
          title: 'Niveau',
          placeholder: 'Sélectionner votre niveau',
          beginner: 'Débutant',
          intermediate: 'Intermédiaire',
          advanced: 'Avancé',
          expert: 'Expert',
        },
      },
    },
    livingPlaces: {
      title: 'Lieux de vie',
      addLivingPlace: {
        title: 'Ajouter un lieu de vie',
        button: 'Sauvegarder',
        country: {
          title: 'Pays',
          placeholder: 'Sélectionner un pays',
        },
        from: {
          title: 'Depuis',
        },
        to: {
          title: "Jusqu'à",
        },
      },
    },
    updateSuccess: 'Profil mis à jour',
    about: {
      title: 'Apprendre plus',
      save: 'Sauvegarder',
      categories: {
        learn: {
          title: 'Que veux-tu apprendre ?',
          placeholder: 'Rechercher tes objectifs...',
        },
        objective: {
          title: 'Objectif',
          placeholder: '#construire une maison...',
        },
        hobby: {
          title: 'Hobby',
          placeholder: '# faire du karate...',
        },
        skills: {
          title: 'Compétences',
          placeholder: '# Marketing...',
        },
      },
    },
  },
  search: {
    placeholder: 'Rechercher',
  },
  imageUpload: {
    fromCamera: 'Prendre une photo',
    fromGallery: 'Importer depuis le téléphone',
  },
  swipeable: {
    mute: 'Sourdine',
    pin: 'Épingler',
    unpin: 'Désépingler',
    delete: 'Effacer',
  },
  errors: {
    title: 'Un problème est survenu',
    logError: 'Veuillez vous connecter de nouveau',
    generic: 'Une erreur est survenue. Veuillez réessayer.',
    'Global.ResourceNotFoundError': 'Ressource introuvable.',
    'Global.OperationNotAllowed': 'Opération non autorisée.',
    'Global.PermissionDenied': "Vous n'avez pas les droits pour effectuer cette action.",
    'Global.ResourceDeletionNotAllowed': 'Cette ressource ne peut pas être supprimée.',
    'Identity.Authentication.Unauthenticated': 'Veuillez vous reconnecter.',
    'Identity.SignIn.InvalidCredentials': 'Email ou mot de passe incorrect.',
    'Identity.SignUp.EmailAlreadyTaken': 'Cet email est déjà utilisé.',
    'Identity.ResetPassword.InvalidOrExpiredToken':
      'Le lien de réinitialisation est invalide ou expiré.',
    'Networking.ContactRequest.SelfContactRequest':
      "Impossible de s'envoyer une demande de contact à soi-même.",
    'Networking.ContactRequest.AlreadyExists':
      'Une demande de contact existe déjà avec cette personne.',
    'Networking.ContactRequest.NotFound': 'Demande de contact introuvable.',
    'Networking.Note.SharedNoteRequiresContact':
      'Une note partagée doit être associée à un contact.',
    'Networking.Note.CannotShareWithSelf': 'Impossible de se partager une note à soi-même.',
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Seuls le créateur ou le contact lié peuvent modifier cette note.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      "Le contact d'une note partagée doit être différent de l'auteur.",
    'Networking.KeepContact.OnlyCreatorCanUpdate': 'Seul le créateur peut modifier ce rappel.',
    'Networking.KeepContact.ContactNotFound': 'Contact introuvable.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate':
      'Seul le créateur peut modifier cet événement.',
    'Networking.CalendarEvent.SomeParticipantsNotFound': 'Certains participants sont introuvables.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired':
      'Veuillez sélectionner un destinataire ou un groupe.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      "Groupe introuvable ou vous n'en êtes pas membre.",
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Seul le créateur peut modifier ce message programmé.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contact introuvable.',
    'Networking.UpdateContactScope.GhostNotAllowed':
      'Le scope ne peut être modifié que pour de vrais contacts.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Seul le propriétaire peut modifier ce profil.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Seul le créateur peut modifier ce hashtag.',
    'Networking.Contact.ProfileNotFound': 'Profil de contact introuvable.',
    'Networking.Contact.RelationshipNotFound': 'Relation de contact introuvable.',
    'Networking.GhostProfile.NotFound': 'Profil fantôme introuvable.',
    'Networking.GhostProfile.NoEmail': "Ce profil fantôme n'a pas d'email enregistré.",
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Profil fantôme introuvable ou non possédé par vous.',
    'Networking.MergeContacts.RealContactNotFound': 'Contact réel introuvable dans vos contacts.',
    'Networking.Profile.NotFoundOrNoRelationship':
      'Profil introuvable ou pas de relation de contact.',
    'Networking.Conversation.NotFound': 'Conversation introuvable.',
    'Ft.Chatbot.ConfirmFailed': "La confirmation de l'action a échoué.",
    'Ft.Chatbot.ChatFailed': 'Le traitement du message a échoué.',
    'Ft.VoiceNote.NoAudioFile': 'Aucun fichier audio fourni.',
    'Ft.VoiceNote.ProcessingFailed': 'Le traitement de la note vocale a échoué.',
    'Ft.ConversationAi.AnalyzeFailed': "L'analyse de la conversation a échoué.",
    'Ft.ConversationAi.GenerateFailed': 'La génération de suggestions a échoué.',
    'Ft.ConversationAi.SummarizeFailed': 'Le résumé de la conversation a échoué.',
    'Ft.BusinessCard.NoImageFile': 'Aucune image fournie.',
    'Ft.BusinessCard.ScanFailed': 'Le scan de la carte de visite a échoué.',
    'Ft.SocialImport.ImportNotFound': 'Import introuvable.',
    'Ft.SocialImport.ResultsNotReady': "Les résultats de l'import ne sont pas encore disponibles.",
    'Ft.SocialImport.NetworkNotEnabled':
      'Le réseau "{network}" n\'est pas activé ou pas configuré.',
    'Ft.SocialImport.UnsupportedNetwork': 'Le réseau "{network}" n\'est pas supporté.',
    'Ft.SocialImport.NotInSucceededStatus': "L'import n'est pas terminé avec succès.",
    'Ft.NearbyVisibility.UpdateFailed': 'La mise à jour de la visibilité de proximité a échoué.',
    'Ft.Translate.Failed': 'La traduction a échoué.',
    'Notifications.DeviceAlreadyRegistered':
      'Cet appareil est déjà enregistré pour les notifications.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'Vous avez atteint la limite de {limit} contacts du forfait gratuit. Passez à Keeptouch Infinity pour des contacts illimités.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'Vous avez atteint la limite de {limit} profils fantômes du forfait gratuit. Passez à Keeptouch Infinity pour des profils fantômes illimités.',
    PLAN_LIMIT_NOTES_REACHED:
      'Vous avez atteint la limite de {limit} notes du forfait gratuit. Passez à Keeptouch Infinity pour des notes illimitées.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'Vous avez atteint la limite de {limit} rappels du forfait gratuit. Passez à Keeptouch Infinity pour des rappels illimités.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Les rappels sont réservés à Keeptouch Infinity. Passez à Keeptouch Infinity pour ne jamais oublier de garder le contact.',
  },
  common: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    statusOverdue: 'Passé',
    statusUpcoming: 'À venir',
    statusDone: 'Terminé',
    all: 'Tous',
    cancel: 'Annuler',
    add: 'Ajouter',
    save: 'Sauvegarder',
    back: 'Retour',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    choose: 'Choisir',
    validate: 'Valider',
    private: 'Privé',
    pro: 'Pro',
    group: 'Groupe',
    personCount: '{count, plural, one {# personne} other {# personnes}}',
    resultsCount: '{count, plural, one {# résultat} other {# résultats}}',
    contactCount: '{count, plural, one {# contact} other {# contacts}}',
    memberCount: '{count, plural, one {# membre} other {# membres}}',
    parenCount: ' ({count})',
    selectedCount: '{count} sélectionné(s)',
    shared: 'Partagé',
    personal: 'Perso',
    filter: 'Filtre',
    momentFilterAll: 'Tout moment',
    momentFilterToday: "Aujourd'hui",
    momentFilterWeek: 'Cette semaine',
    momentFilterMonth: 'Ce mois',
    momentFilterLater: 'Plus tard',
    scanBusinessCard: 'Scanner une carte de visite',
    inCommon: 'En commun',
    viewMyProfile: 'Voir mon profil',
    view: 'Voir',
    retry: 'Réessayer',
  },
  featureTooltip: {
    gotIt: 'OK, compris !',
    conversation_ai_panel: {
      description:
        'Suggérer : génère une réponse. Résumer : synthèse. Analyser : sentiment et sujets.',
    },
    scheduled_messages: {
      title: 'Messages programmés',
      description:
        "Planifiez des messages à envoyer plus tard. L'IA peut générer le message pour vous selon la raison (anniversaire, prise de nouvelles...). Glissez pour modifier ou supprimer.",
    },
    scheduled_msg_reason: {
      title: 'Génération IA',
      description:
        "Choisissez une raison et ajoutez des détails optionnels. L'IA rédigera un message personnalisé adapté au contexte et à votre relation avec le contact.",
    },
    nearby_intro: {
      title: 'Contacts à proximité',
      description:
        'Découvrez quels contacts se trouvent près de vous, dans la même ville ou le même pays. Votre position est mise à jour automatiquement à chaque connexion.',
    },
    keep_contact: {
      title: 'Rappels de contact',
      description:
        "Créez des rappels pour ne jamais oublier de recontacter quelqu'un. Définissez une date, une récurrence et filtrez par catégorie ou hashtag. Les rappels en retard apparaissent en rouge.",
    },
    graph_intro: {
      title: 'Graphe relationnel',
      description:
        'Explorez visuellement vos contacts et leurs relations. Zoomez, glissez et cliquez sur un contact pour voir son profil. Passez en mode Complet pour voir les liens par catégorie, hashtag, ville...',
    },
    listing_contacts: {
      title: 'Vos contacts',
      description:
        'Filtrez par Privé ou Pro avec les onglets. Utilisez le + pour ajouter un contact manuellement, scanner une carte de visite ou importer depuis un réseau social.',
    },
    card_scanner: {
      title: 'Scanner de carte de visite',
      description:
        "Prenez en photo ou importez une carte de visite. L'IA extraira automatiquement les informations et créera un nouveau contact.",
    },
    social_import: {
      title: 'Import de contacts sociaux',
      description:
        "Sélectionnez un réseau social et entrez un nom d'utilisateur. L'IA importera automatiquement les abonnés/contacts de ce profil dans votre carnet.",
    },
    merge_intro: {
      title: 'Fusionner les doublons',
      description:
        "L'IA détecte les contacts en double. Swipez à droite pour fusionner, à gauche pour ignorer. Cliquez sur un profil pour le consulter avant de décider.",
    },
    classify_swipe: {
      title: 'Classez vos contacts',
      description:
        'Swipez vers la gauche pour classer en Privé, vers la droite pour Pro. Vous pouvez aussi utiliser les boutons. Cliquez sur la carte pour voir le profil.',
    },
    chatbot_intro: {
      title: 'Assistant IA',
      description:
        "Posez des questions sur vos contacts, demandez des suggestions ou effectuez des actions comme programmer un message. L'IA peut chercher, analyser et agir pour vous.",
    },
  },
  graphScreen: {
    title: 'Graphe relationnel',
    nativeWebOnlyBody: 'La visualisation du graphe est disponible sur la version web.',
    nativeWebOnlySubtext:
      'Connectez-vous sur keeptouch.co pour explorer vos relations de manière interactive.',
    loadingGraph: 'Chargement du graphe…',
    mode: 'Mode',
    modeContacts: 'Contacts',
    modeFull: 'Complet',
    relations: 'Relations',
    statsLine: '{nodeCount} nœuds · {edgeCount} liens',
    edgeContact: 'Contacts',
    edgeCategory: 'Catégories',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Professions',
    edgeNationality: 'Nationalités',
    edgeCity: 'Villes',
    legendMe: 'Moi',
    legendPrivate: 'Privé',
    legendPro: 'Pro',
    legendGhost: 'Fantôme',
    legendCategory: 'Catégorie',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profession',
    legendNationality: 'Nationalité',
    legendCity: 'Ville',
    searchPlaceholder: 'Rechercher dans le graphe',
  },
  geolocation: {
    unavailable: {
      title: 'Géolocalisation indisponible',
      message: "La géolocalisation n'est pas disponible sur cet appareil.",
    },
    denied: {
      title: 'Permission refusée',
      message:
        "Nous avons besoin d'accéder à votre localisation pour vous offrir une meilleure expérience. Voulez-vous ouvrir les paramètres pour activer la géolocalisation ?",
      cancel: 'Annuler',
      settings: 'Paramètres',
    },
    blocked: {
      title: 'Permission bloquée',
      message:
        "L'accès à la géolocalisation a été bloqué. Veuillez aller dans les paramètres de l'application pour l'activer manuellement.",
      cancel: 'Annuler',
      settings: 'Paramètres',
    },
  },
  contacts: {
    searchProfile: 'Rechercher un profil',
    addNonExistingProfile: 'Ajouter un profil non existant',
    importFromContacts: 'Importer depuis mes contacts',
    importFrom: 'Importer depuis {network}',
    uncontact: 'Retirer de mes contacts',
    uncontactConfirmTitle: 'ce contact',
  },
  settings: {
    title: 'Paramètres',
    language: 'Langue',
    languageDescription: "Choisissez la langue de l'application",
    auto: "Automatique (langue de l'appareil)",
    french: 'Français',
    english: 'English',
    spanish: 'Español',
    location: 'Localisation',
    locationDescription: "Gérer l'accès à votre localisation",
    locationStatusUnknown: 'Statut : non vérifié',
    locationStatusEnabled: 'Statut : activée',
    locationStatusDisabled: 'Statut : désactivée ou indisponible',
    locationAction: "Vérifier l'autorisation de localisation",
    locationToggle: 'Activer la localisation',
    locationDenied: 'Localisation bloquée par le navigateur. Autorisez-la pour ce site.',
    subscription: 'Abonnement',
    subscriptionDescription: 'Votre offre KeepTouch actuelle',
    subscriptionFree: 'Offre gratuite',
    subscriptionManage: 'Voir les offres Premium',
    subscriptionPremium: 'Premium actif',
    calendarSync: 'Synchronisation du calendrier',
    calendarSyncDescription: 'Ajoutez vos événements KeepTouch à votre calendrier.',
    calendarSyncEnable: 'Synchroniser avec mon calendrier',
    calendarSyncPermissionDenied: 'L’autorisation calendrier est nécessaire pour synchroniser.',
    deleteAccountTitle: 'Supprimer mon compte',
    deleteAccountDescription:
      'Supprime définitivement votre compte et toutes vos données. Cette action est irréversible.',
    deleteAccountButton: 'Supprimer mon compte',
    deleteAccountConfirmTitle: 'Supprimer votre compte ?',
    deleteAccountConfirmMessage:
      'Cette action est définitive : votre compte et toutes vos données (contacts, notes, messages…) seront supprimés. Vous ne pourrez pas les récupérer.',
    deleteAccountCancel: 'Annuler',
    deleteAccountConfirm: 'Supprimer définitivement',
    deleteAccountInProgress: 'Suppression…',
    deleteAccountPasswordPlaceholder: 'Entrez votre mot de passe',
    deleteAccountWrongPassword: 'Mot de passe incorrect.',
    deleteAccountError: 'La suppression du compte a échoué. Veuillez réessayer.',
  },
  calendarModal: {
    month0: 'Janvier',
    month1: 'Février',
    month2: 'Mars',
    month3: 'Avril',
    month4: 'Mai',
    month5: 'Juin',
    month6: 'Juillet',
    month7: 'Août',
    month8: 'Septembre',
    month9: 'Octobre',
    month10: 'Novembre',
    month11: 'Décembre',
    weekDay0: 'LUN',
    weekDay1: 'MAR',
    weekDay2: 'MER',
    weekDay3: 'JEU',
    weekDay4: 'VEN',
    weekDay5: 'SAM',
    weekDay6: 'DIM',
    time: 'Heure',
    schedule: 'Programmer',
    subscriptionManage: 'Voir les offres Premium',
    subscriptionPremium: 'Premium actif',
  },
  connectedServices: {
    sectionTitle: 'Services connectés',
    sectionDescription:
      'Connectez vos messageries pour importer automatiquement vos contacts dans KeepTouch.',
    connect: 'Connecter',
    connected: 'Connecté',
    reconnect: 'Reconnecter',
    statusConnecting: 'Connexion…',
    wizardOpened: 'Finalisez la connexion dans l’onglet qui vient de s’ouvrir, puis revenez ici.',
    disconnect: 'Déconnecter',
    disconnected: 'Service déconnecté.',
    disconnectError: 'La déconnexion a échoué, réessayez.',
    wizardError: 'Impossible de créer le lien de connexion, réessayez.',
    refresh: 'Actualiser',
    filterPlaceholder: 'Filtre (optionnel) : ex. cybersécurité, finance, recrutement…',
    syncFilteredOut: '{filtered} contact(s) hors critère non importé(s)',
    syncStarted: "Importation lancée — cela peut prendre quelques minutes. Inutile de déconnecter le service, tout arrive ! ⏳",
    syncInProgressHint: "Importation en cours… Cela peut prendre quelques minutes, vous pouvez continuer à utiliser l'application.",
    syncNow: 'Importer mes contacts',
    syncing: 'Import en cours…',
    syncResult: '{created} contact(s) importé(s), {skipped} déjà présent(s)',
    syncEmpty: 'Aucun nouveau contact à importer',
    syncError: 'L’import a échoué, réessayez.',
    planLimit: 'Limite du plan gratuit atteinte — certains contacts n’ont pas été importés.',
    noAccounts: 'Aucun service connecté pour l’instant.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Synchroniser Google Agenda',
    calendarSyncing: 'Synchronisation…',
    calendarConnect: 'Connecter Google Agenda',
    calendarSyncResult: '{created} événement(s) importé(s), {skipped} déjà présent(s)',
    calendarSyncEmpty: 'Agenda déjà à jour',
    calendarSyncError: 'La synchronisation a échoué, réessayez.',
  },
  subscription: {
    title: 'Abonnement',
    headline: 'Choisissez votre expérience Keeptouch',
    intro: 'Deux formules pour développer et entretenir votre réseau humain, à votre rythme.',
    // Version Gratuite
    freeTierTitle: 'Version Gratuite',
    freeTierSubtitle: 'Pour découvrir Keeptouch et structurer ses premiers contacts.',
    freePriceLabel: 'Gratuit',
    freeFeatureContacts: 'Jusqu’à 500 contacts synchronisables',
    freeFeatureGhosts: '30 profils fantômes',
    freeFeatureNotes: '10 notes personnelles maximum',
    freeFeatureReminders: '3 rappels actifs',
    freeFeatureMap: 'Carte relationnelle en version simplifiée',
    freeFeatureNoStats: 'Aucune statistique ou insight intelligent',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'L’expérience complète pour les bâtisseurs de réseau humain.',
    infinityBadge: 'Recommandé',
    infinityPriceFallback: '6,99 €/mois',
    infinityPricePerMonth: '{price}/mois',
    infinityFeatureUnlimited: 'Tout en illimité',
    infinityFeatureGhosts: 'Profils fantômes illimités',
    infinityFeatureAI: 'IA relationnelle (analyse des liens, alertes, priorisation intelligente)',
    infinityFeatureIntegrations: 'Intégrations avancées WhatsApp, calendrier, réseaux sociaux',
    infinityFeatureMap: 'Carte réseau dynamique et évolutive',
    infinityFeatureForecast: 'Prévisions d’évolution des relations',
    infinityCta: 'Lancer Keeptouch Infinity',
    comingSoon: 'Bientôt disponible',
    comingSoonMessage: 'Keeptouch Infinity arrive très bientôt. Merci de votre patience !',
    premiumTitle: 'Vous êtes Infinity',
    premiumSubtitle: 'Merci de faire partie de Keeptouch Infinity. Vous profitez de toutes les fonctionnalités, sans limite.',
    premiumActive: 'Abonnement actif',
    expiresOn: 'Renouvellement le {date}',
    processing: 'Traitement…',
    activating: 'Activation de votre abonnement…',
    purchaseSuccessTitle: 'Bienvenue chez Keeptouch Infinity',
    purchaseSuccessMessage: 'Votre abonnement est actif. Profitez de toutes les fonctionnalités !',
    purchaseErrorTitle: 'Achat impossible',
    purchaseErrorMessage: 'L’achat n’a pas pu aboutir. Veuillez réessayer.',
    restoreCta: 'Restaurer mes achats',
    restoring: 'Restauration…',
    restoreSuccessTitle: 'Abonnement restauré',
    restoreSuccessMessage: 'Votre abonnement Infinity a bien été restauré.',
    restoreNoneTitle: 'Aucun achat à restaurer',
    restoreNoneMessage: 'Nous n’avons trouvé aucun abonnement actif sur ce compte.',
    restoreErrorTitle: 'Restauration impossible',
    restoreErrorMessage: 'La restauration a échoué. Veuillez réessayer.',
    manageCta: 'Gérer mon abonnement',
    manageErrorTitle: 'Ouverture impossible',
    manageErrorMessage: 'Impossible d’ouvrir la page de gestion de l’abonnement.',
    legalDisclosure:
      'Abonnement mensuel à renouvellement automatique de 6,99 €/mois. Il se renouvelle automatiquement sauf résiliation au moins 24 h avant la fin de la période. Résiliable à tout moment dans les réglages de votre compte.',
    termsOfUse: 'Conditions d’utilisation',
    privacyPolicy: 'Politique de confidentialité',
  },
  planLimit: {
    title: 'Passez à Keeptouch Infinity',
    body: 'Vous avez atteint une limite du forfait gratuit. Passez à Keeptouch Infinity pour débloquer cette fonctionnalité.',
    upgrade: 'Passer à Keeptouch Infinity',
    later: 'Plus tard',
  },
  export: {
    sectionTitle: 'Exporter mes contacts',
    sectionDescription:
      'Téléchargez tous vos contacts au format vCard (.vcf), réimportable dans n’importe quel carnet d’adresses.',
    cta: 'Exporter mes contacts (.vcf)',
    exporting: 'Export en cours…',
    successTitle: 'Export réussi',
    successMessage: 'Vos contacts ont été exportés au format vCard.',
  },
  recurrence: {
    title: 'Récurrence',
    custom: 'Personnalisée',
    recurrence: 'Récurrence',
    every: 'Tous les',
    everyDay: 'Tous les jours',
    everyWeek: 'Toutes les semaines',
    every2Weeks: 'Toutes les 2 semaines',
    every6Weeks: 'Toutes les 6 semaines',
    everyMonth: 'Tous les mois',
    every3Months: 'Tous les 3 mois',
    every6Months: 'Tous les 6 mois',
    everyYear: 'Tous les ans',
    repeatOn: 'Répéter le',
    end: 'Fin',
    never: 'Jamais',
    on: 'Le',
    after: 'Après',
    lastDayOfMonth: 'Dernier jour du mois',
    day: 'jour',
    week: 'semaine',
    month: 'mois',
    year: 'an',
    repetition: 'répétition',
  },
  calendarEvent: {
    createEvent: 'Créer un rendez-vous',
    editEvent: 'Modifier le rendez-vous',
    shared: 'Partagé',
    sharedCount: '{count, plural, one {Partagé} other {Partagés}}',
    personal: 'Perso',
    eventName: 'Nom du rendez-vous',
    eventNamePlaceholder: 'Nom du rendez-vous...',
    addGuests: 'Ajouter des invités',
    searchGuests: 'Rechercher des invités...',
    eventDate: "Date de l'évènement",
    allDay: 'Toute la journée',
    addLocation: 'Ajouter un lieu',
    locationTitle: 'Lieu',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    alert: 'Alerte',
    alertEnabled: 'Alerte activée',
    noAlert: 'Aucune alerte',
    inviteAndAdd: 'Inviter et ajouter sur KeepTouch',
    addToCalendar: 'Ajouter seulement sur KeepTouch',
    addToGoogle: 'Ajouter à Google Agenda',
    deleteConfirm: 'Supprimer ce rendez-vous ?',
    markAsDone: 'Marquer comme fait',
    markAsNotDone: 'Marquer comme non fait',
  },
  ghostProfile: {
    inviteToJoin: 'Inviter à rejoindre',
    inviteSent: 'Invitation envoyée par e-mail.',
    inviteError: "Impossible d'envoyer l'invitation. Veuillez réessayer.",
    inviteErrorNoEmail:
      "Ce profil n'a pas d'adresse e-mail. Ajoutez une adresse e-mail pour envoyer une invitation.",
    editProfile: 'Modifier le profil',
    about: 'À propos',
    presentation: 'Présentation',
    birthday: 'Anniversaire',
    languages: 'Langues',
    nationalities: 'Nationalités',
    origins: 'Origines',
    contactInfo: 'Coordonnées',
    email: 'Mail',
    phone: 'Numéro',
    website: 'Site web',
    availabilities: 'Disponibilités',
    livedPlaces: 'Lieux de résidence',
    categories: 'Catégories',
    searchCategories: 'Rechercher des catégories',
    keepContact: 'Garder contact',
    context: 'Contexte',
    hashtag: 'Hashtag',
    searchHashtags: 'Rechercher des hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objectifs',
    hobby: 'Hobby',
    skills: 'Compétences',
    notes: 'Notes',
    appointments: 'Rendez-vous / Rappel',
    memories: 'Souvenirs',
    shareProfile: 'Partager',
    message: 'Message',
    requestSent: 'Demande envoyée',
    openOnKeepTouch: 'Ouvrir sur KeepTouch',
    edit: 'Modifier',
    deleteProfile: 'Supprimer le profil',
    deleteConfirmTitle: 'ce profil fantôme',
    deleteSuccess: 'Profil fantôme supprimé',
    updateSuccess: 'Profil fantôme mis à jour',
    createSuccess: 'Profil fantôme créé',
    lastInteraction: 'Dernière interaction {time}',
    noInteractionYet: "Aucune interaction pour l'instant",
    viewMyProfile: 'Voir mon profil',
    aboutProfile: 'À propos du profil',
    pins: 'Pins',
  },
  contextes: {
    title: 'Contextes',
    meetingContext: 'Cadre de la rencontre',
    associatedEmotion: 'Émotion associée',
    relationshipEvolution: 'Évolution de la relation',
    associatedColor: 'Couleur associée',
    referencePlace: 'Lieu de référence',
    enterPlace: 'Entrez un lieu',
    chooseMeetingContext: 'Choisir le cadre de la rencontre',
    editMeetingContext: 'Modifier le cadre de la rencontre',
    chooseEmotion: "Choisir l'émotion associée",
    editEmotion: "Modifier l'émotion associée",
    chooseRelationship: "Choisir l'évolution de la relation",
    editRelationship: "Modifier l'évolution de la relation",
    chooseColor: 'Choisir la couleur associée',
    editColor: 'Modifier la couleur associée',
    searchMeetingContext: 'Rechercher un cadre de la rencontre',
    searchEmotion: 'Rechercher une émotion associée',
    searchRelationship: 'Rechercher une évolution de la relation',
    searchColor: 'Rechercher une couleur associée',
    save: 'Sauvegarder',
    unsavedTitle: 'Modifications non sauvegardées',
    unsavedMessage: 'Êtes-vous sûr de ne pas sauvegarder ?',
    leaveWithoutSaving: 'Quitter sans sauvegarder',
    keepEditing: 'Annuler',
  },
  categories: {
    notFound: 'Catégorie non trouvée',
    changePhoto: 'Changer la photo',
    chooseOption: 'Choisissez une option',
    gallery: 'Galerie',
    camera: 'Appareil photo',
    person: 'personne',
    persons: 'personnes',
  },
  importContacts: {
    back: 'Retour',
    importCard: 'Importer une carte de visite',
    businessCard: 'Carte de visite',
    dragCard: 'Faites glisser la carte de visite ici',
    or: 'Ou',
    selectFiles: 'Sélectionner parmi vos fichiers',
    supportedFormats: 'Format pris en charge : PDF, JPEG, PNG',
    startImport: "Lancer l'import",
    contactFound: 'Contact trouvé sur KeepTouch',
    profileFound: 'Profil trouvé!',
    addNewContact: 'Ajouter un nouveau contact :',
    validate: 'Valider et enregistrer la fiche',
    validating: 'Enregistrement…',
    checkInfo: 'Vérifier les informations importées',
    firstName: 'Prénom',
    enterFirstName: 'Entrez le prénom',
    lastName: 'Nom',
    enterLastName: 'Entrez le nom',
    profession: 'Profession',
    enterProfession: 'Entrez la profession',
    company: 'Entreprise',
    enterCompany: "Entrez l'entreprise",
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    website: 'Site web',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Nom du #...',
    categoriesLabel: 'Catégories',
    addNewContactButton: 'Ajouter un nouveau contact',
    searchProfession: 'Rechercher une profession',
    file: {
      title: 'Importer depuis un fichier CSV',
      subtitle:
        'Déposez un export CSV de votre CRM : un profil fantôme sera créé automatiquement pour chaque contact.',
      drag: 'Faites glisser votre fichier ici',
      formats: 'Format pris en charge : CSV (.csv)',
      fullName: 'Nom complet',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notes',
      unsupportedFormat: 'Format non pris en charge. Choisissez un fichier CSV (.csv). Les fichiers Excel doivent d’abord être exportés en CSV.',
      empty: 'Le fichier ne contient aucune ligne de contact.',
      parseError: "Impossible de lire le fichier. Vérifiez qu'il est bien au format CSV.",
      detected: '{count} contact(s) détecté(s) dans le fichier',
      columnsDetected: 'Colonnes reconnues automatiquement :',
      noUsableRows: 'Aucune ligne exploitable : il faut au moins un nom, un email ou un téléphone.',
      importButton: 'Importer {count} contact(s)',
      importing: 'Création des profils… {done} / {total}',
      doneTitle: '{count} contact(s) importé(s) avec succès',
      doneDetails: '{skipped} ligne(s) ignorée(s), {failed} en échec',
      importAnother: 'Importer un autre fichier',
      importedToast: '{count} profil(s) fantôme(s) créé(s)',
    },
  },
  contactsList: {
    noContactFound: 'Aucun contact trouvé',
    contactViaSocial: 'Contacter via les réseaux sociaux',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contacter via LinkedIn',
    contactViaFacebook: 'Contacter via Facebook',
    contactViaInstagram: 'Contacter via Instagram',
    contactViaTwitter: 'Contacter via Twitter',
  },
  keepContact: {
    editReminder: 'Modifier le suivi',
    createReminder: 'Créer un suivi',
    reminderTitle: 'Titre du suivi',
    reminderTitlePlaceholder: 'Nom du suivi...',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    addContact: 'Ajouter un contact',
    searchContact: 'Rechercher un contact...',
    contactLabel: 'Contact',
    eventDate: "Date de l'évènement",
    addLocation: 'Ajouter un lieu',
    location: 'Lieu',
    alert: 'Alerte',
    alertEnabled: 'Alerte activée',
    noAlert: 'Aucune alerte',
    alertActive: 'Active',
    alertInactive: 'Non active',
    backToProfile: 'Retour au profil',
    pageTitle: 'Garder contact',
    reminder: 'suivi',
    reminders: 'suivis',
    deleteConfirm: 'ce suivi',
    filter: 'Filtre',
    none: 'Aucune récurrence',
    keepContactWith: 'Garder contact avec {contactName}',
    listView: 'Liste',
    boardView: 'Tableau',
  },
  photoAlert: {
    title: 'Choisir une photo',
    message: 'Sélectionnez une option',
  },
  qrCode: {
    shareMessage: 'Découvrez mon profil KeepTouch : {url}',
    shareTitle: 'Mon profil KeepTouch',
    error: 'Erreur',
    shareError: 'Impossible de partager le profil',
    success: 'Succès',
    linkCopied: 'Lien copié dans le presse-papiers',
    copyError: 'Impossible de copier le lien',
    info: 'Information',
    downloadTodo: 'Fonctionnalité de téléchargement à implémenter',
    notKeepTouchUrl: 'Ce QR code ne contient pas de lien vers un profil KeepTouch.',
    scanTitle: 'Scanner un QR Code',
    scanInstruction: 'Pointez votre caméra vers un QR code KeepTouch pour le scanner.',
    scanWebFallbackActive: 'Utilisation du scanner alternatif pour votre navigateur.',
    cameraPermissionTitle: 'Accès à la caméra requis',
    cameraPermissionMessage:
      "Veuillez autoriser l'accès à la caméra dans les paramètres de votre navigateur pour scanner des QR codes.",
  },
  webNav: {
    search: 'Rechercher',
    allContacts: 'Tous mes contacts',
    messaging: 'Messagerie',
    notifications: 'Notifications',
    myProfile: 'Mon profil',
    signOut: 'Se déconnecter',
    settings: 'Paramètres',
  },
  menuItems: {
    importContacts: 'Importer des contacts',
    classifyProfiles: 'Classer des profils',
    mergeProfiles: 'Fusionner des profils',
    maps: 'Cartes',
    notes: 'Notes',
    categories: 'Catégories',
    hashtags: 'Hashtags',
    relationalColors: 'Couleurs relationnelles',
    appointments: 'Rendez-vous / Rappel',
    birthdays: 'Anniversaires',
    keepContact: 'Garder contact',
    scheduledMessages: 'Messages programmés',
    qrCode: 'QR code',
    settings: 'Paramètres',
    graph: 'Graphe relationnel',
    nearby: 'Contacts à proximité',
  },
  form: {
    contactInfo: 'Info de contact',
    about: 'À propos',
    woman: 'Une femme',
    man: 'Un homme',
    mainInfo: 'Informations principales',
    firstName: 'Prénom',
    enterFirstName: 'Entrez le prénom',
    lastName: 'Nom',
    enterLastName: 'Entrez le nom',
    professions: 'Profession(s)',
    enterProfession: 'Entrez la profession',
    company: 'Entreprise',
    enterCompany: "Nom de l'entreprise (facultatif)",
    email: 'Email',
    phoneNumber: 'Numéro de téléphone',
    socialNetworks: 'Réseaux sociaux',
    website: 'Site web',
    descriptionPlaceholder: 'Description...',
    presentation: 'Présentation',
    birthDate: 'Date de naissance',
    livingPlace: 'Lieu de vie',
    origins: 'Origines',
    nationalities: 'Nationalités',
    nationalityPlaceholder: 'Nationalité',
    spokenLanguages: 'Langues parlées',
    enterLanguages: 'Entrez les langues',
    livedPlaces: 'Lieux vécus',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Disponibilités et types de rencontres',
    availability: 'Disponibilités',
    bestMoment: 'Meilleur moment',
    bestMoments: 'Meilleurs moments',
    chooseDay: 'Choisir un jour',
    chooseTime: "Choisir l'heure",
    days: {
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
    },
    searchLanguage: 'Rechercher une langue',
    searchPlace: 'Rechercher un lieu',
    searchNationality: 'Rechercher une nationalité',
    searchHashtags: 'Rechercher des hashtags',
    searchCategories: 'Rechercher des catégories',
    searchProfession: 'Rechercher une profession',
    backToProfile: 'Retour au profil',
    backToContacts: 'Retour à la liste des contacts',
    editGhostProfile: 'Modifier le profil fantôme',
    createGhostProfile: 'Créer un profil fantôme',
    addMeetingContext: 'Ajouter cadre de rencontre',
    addNewContact: 'Ajouter un nouveau contact',
    addNewProfile: 'Ajouter un nouveau profil',
    addContact: 'Ajouter un contact',
    searchContact: 'Rechercher un contact...',
    addNonExistingProfile: 'Ajouter un profil non existant',
  },
  messaging: {
    searchPlaceholder: 'Rechercher un message ou un contact',
    groupNamePlaceholder: 'Nom du groupe (optionnel)',
    recipientPlaceholder: 'Saisir votre destinataire...',
    messagePlaceholder: 'Saisissez votre message ...',
    seen: 'Vu',
    aboutGroup: 'À propos du groupe',
    createNewMessage: 'Créer un nouveau message',
  },
  profileEdit: {
    editMyProfile: 'Modifier mon profil',
    backToMyProfile: 'Retour à mon profil',
    about: 'À propos :',
    categories: 'Catégories',
    searchCategories: 'Rechercher des catégories',
  },
  livingPlaceForm: {
    editTitle: 'Modifier le lieu de résidence',
    addTitle: 'Ajouter un lieu de résidence',
    place: 'Lieu',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    currently: 'Actuellement',
  },
  notesForm: {
    addNote: 'Ajouter une note',
    editNote: 'Modifier la note',
    titlePlaceholder: 'Titre',
    notePlaceholder: 'Note',
    sharedWith: 'Partagée avec ',
    addContact: 'Ajouter un contact',
    selectContactTitle: 'Choisir un contact',
    personalNote: 'Note personnelle',
    personalNoteSubtitle: 'Pour vous-même',
  },
  recurrenceComponent: {
    everyDay: 'Tous les jours',
    everyWeek: 'Toutes les semaines',
    everyMonth: 'Tous les mois',
    everyYear: 'Tous les ans',
    recurrence: 'Récurrence',
    every: 'Tous les',
    repeatOn: 'Répéter le',
    monthDetail: 'Détail par mois',
    lastDayOfMonth: 'Dernier jour du mois',
    end: 'Fin',
    never: 'Jamais',
    on: 'Le',
    after: 'Après',
    day: 'jour',
    days: 'jours',
    week: 'semaine',
    weeks: 'semaines',
    month: 'mois',
    year: 'an',
    years: 'ans',
    repetition: 'répétition',
    repetitions: 'répétitions',
  },
  filters: {
    title: 'Filtres',
    gender: 'Sexe',
    age: 'Âge',
    min: 'Min',
    max: 'Max',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Féminin',
    genderMaleLong: 'Masculin',
    genderNonBinaryLong: 'Non binaire',
    residence: 'Lieu de vie',
    residenceContinent: 'Continent',
    residenceCountry: 'Pays',
    residenceRegion: 'Région',
    residenceCity: 'Ville',
    livedPlaces: 'Lieux vécus',
    origin: 'Origine',
    nationality: 'Nationalité',
    profession: 'Fonction',
    meetingContext: 'Cadre de la rencontre',
    associatedEmotion: 'Émotion associée',
    relationshipEvolution: 'Évolution de la relation',
    associatedColor: 'Couleur associée',
    language: 'Langue',
    category: 'Catégorie',
    hashtag: 'Hashtag',
    searchPlace: 'Rechercher un lieu',
    activitySector: "Secteur d'activité",
    searchSector: 'Rechercher un secteur',
    searchHashtags: 'Rechercher des hashtags',
    searchHashtag: 'Rechercher un hashtag',
    searchCategories: 'Rechercher des catégories',
    searchCategory: 'Rechercher une catégorie',
    searchMeetingContext: 'Rechercher un cadre de la rencontre',
    searchEmotion: 'Rechercher une émotion associée',
    searchRelationship: 'Rechercher une évolution de la relation',
    searchColor: 'Rechercher une couleur associée',
    searchLanguage: 'Rechercher une langue',
    contact: 'Contact',
    eventDate: "Date de l'évènement",
    addPlace: 'Ajouter un lieu',
    place: 'Lieu',
  },
  hashtagForm: {
    addTitle: 'Ajouter un hashtag',
    editTitle: 'Modifier le hashtag',
    backToList: 'Retour à la liste des hashtags',
    namePlaceholder: 'Nom...',
  },
  deleteModal: {
    confirmMessage: 'Êtes-vous sûr de vouloir supprimer {title} ?',
    delete: 'Supprimer',
    cancel: 'Annuler',
  },
  relationalColorForm: {
    editTitle: 'Modifier la couleur relationnelle',
    namePlaceholder: 'Nom...',
  },
  addContactModal: {
    addPerson: 'Ajouter {name}',
    addDefaultPerson: 'Ajouter nom de la personne',
    addPrivate: 'Ajouter en Privé',
    addProfessional: 'Ajouter en Professionnel',
    requestSent: 'Demande envoyée',
  },
  addHashtagModal: {
    title: 'Ajouter un hashtag',
    save: 'Enregistrer',
  },
  addCategoryModal: {
    title: 'Ajouter une catégorie',
    save: 'Enregistrer',
  },
  menuContactsList: {
    addContacts: 'Ajouter des contacts',
    linkedContacts: 'Contacts liés',
  },
  memoriesForm: {
    addPhoto: 'Ajouter une photo',
    editMemory: 'Modifier le souvenir',
    addMemory: 'Ajouter un souvenir',
    memory: 'Souvenir',
    selectMemory: 'Sélectionnez un souvenir',
    description: 'Description :',
    identifyContacts: 'Identifier des contacts :',
    identifiedContacts: 'Contacts identifiés',
    publish: 'Publier',
    sharedMemories: 'Souvenirs partagés',
    sharedAlbums: 'Albums partagés',
    deleteMemoryDescription: "Voulez-vous supprimer uniquement cette photo ou l'album entier ?",
    deletePhoto: 'Supprimer cette photo',
    deleteAlbum: "Supprimer l'album",
    deleteAlbumDescription: 'Êtes-vous sûr de vouloir supprimer cet album entièrement ?',
  },
  albums: {
    title: 'Albums',
    createAlbum: 'Créer un album',
    albumName: "Nom de l'album",
    albumTitle: "Titre de l'album",
    defaultTitle: 'Mon album',
    description: 'Description',
    empty: 'Aucun album pour le moment',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet album ?',
  },
  creationStack: {
    addNote: 'Ajouter une note',
    conversation: 'Conversation',
    createEvent: 'Créer un événement',
    addReminder: 'Ajouter un rappel',
    scheduleMessage: 'Programmer un message',
    composeMessage: 'Rédiger un message',
  },
  calendarAddEvent: {
    notActive: 'Non active',
    active: 'Active',
  },
  toast: {
    success: 'Succès',
    error: 'Erreur',
    info: 'Info',
    scheduledMessageDeleted: 'Message programmé supprimé',
    scheduledMessageCreated: 'Message programmé créé',
    scheduledMessageUpdated: 'Message programmé mis à jour',
    reminderUpdated: 'Rendez-vous / Rappel mis à jour',
    reminderDeleted: 'Rendez-vous / Rappel supprimé',
    reminderCreated: 'Rendez-vous / Rappel créé',
    eventDeleted: 'Événement supprimé',
    eventCreated: 'Événement créé',
    eventUpdated: 'Événement mis à jour',
    colorUpdated: 'Couleur mise à jour',
    contactRequestSent: 'Demande envoyée',
    contactRequestSentMessage: "Votre demande d'ami a bien été envoyée.",
    scopeChanged: 'Scope modifié',
    categoryUpdated: 'Catégorie mise à jour',
    categoryCreated: 'Catégorie créée',
    categoryDeleted: 'Catégorie supprimée',
    noteCreated: 'Note créée',
    noteUpdated: 'Note mise à jour',
    noteDeleted: 'Note supprimée',
    hashtagUpdated: 'Hashtag mis à jour',
    hashtagDeleted: 'Hashtag supprimé',
    hashtagCreated: 'Hashtag créé',
    memoryCreated: 'Souvenir ajouté',
    memoryUpdated: 'Souvenir modifié',
    memoryDeleted: 'Souvenir supprimé',
    albumCreated: 'Album créé',
    albumDeleted: 'Album supprimé',
  },
  voiceNote: {
    error: 'Erreur lors du traitement de la note vocale',
    vocal: 'Vocal',
    successProfileUpdated: 'Profil mis à jour',
    successNoteCreated: 'Note créée',
    successProcessed: 'Note vocale traitée',
  },
  messagesScreen: {
    private: 'Privé',
    pro: 'Pro',
    groups: 'Groupes',
    other: 'Autre',
    pinnedMessages: 'Voir les messages épinglés',
    viewNotes: 'Voir les notes',
    viewMedia: 'Voir les médias',
    viewMembers: 'Voir les membres',
    customizeGroup: 'Personnaliser le groupe',
    share: 'Partager',
    block: 'Bloquer',
    report: 'Signaler',
    group: 'Groupe',
    members: 'Membres',
    persons: '{count} personnes',
  },
  contactsScreen: {
    personFound: 'personne trouvée',
    personsFound: 'personnes trouvées',
    noContactFound: 'Aucun contact trouvé',
    professionNotSpecified: 'Profession non renseignée',
    profilesRemainingToMerge: 'profils restants à fusionner',
    profileRemainingToMerge: 'profil restant à fusionner',
    noProfileToMerge: 'Aucun profil à fusionner',
    mergeProfiles: 'Fusionner les profils',
    merge: 'Fusionner',
    swipeToMerge: 'Swiper à droite pour fusionner, à gauche pour ignorer.',
    swipeMergeInstruction: 'Swiper à droite pour fusionner, à gauche pour ignorer.',
    profilesRemainingToClassify: 'profils restants à classer',
    profileRemainingToClassify: 'profil restant à classer',
    noProfileToClassify: 'Aucun profil à classer',
    classifyProfiles: 'Classer les profils',
    swipeToClassify: 'Swiper à droite ou à gauche pour définir le contact comme pro ou privé.',
    swipeClassifyInstruction:
      'Swiper à droite ou à gauche pour définir le contact comme pro ou privé.',
    coordinates: 'Coordonnées',
    import: 'Importer',
    importContacts: 'Import des contacts',
    importAll: 'Importer tout',
    allContactsImported: 'Tous les contacts ont été importés',
    pleaseSyncContacts: 'Veuillez synchroniser vos contacts',
    allImported: 'Tous les contacts ont été importés',
    syncContacts: 'Synchroniser mes contacts',
    selected: 'sélectionné',
    contactFound: 'Contact trouvé!',
    profileFound: 'Profil trouvé!',
    contactFoundScan: 'Contact trouvé!',
    profileFoundScan: 'Profil trouvé!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'Aucun lieu de résidence ajouté',
    pressToAddFirstPlace: 'Appuyez sur + pour ajouter votre premier lieu',
    tapToAddFirstPlace: 'Appuyez sur + pour ajouter votre premier lieu',
    noDataAdded: 'Aucune donnée ajoutée',
    noAvailabilityAdded: 'Aucune disponibilité ajoutée',
    noContactInfoAdded: 'Aucune coordonnée ajoutée',
    noHashtagAdded: 'Aucun hashtag ajouté',
    backToMyProfile: 'Retour à mon profil',
    aboutSection: 'À propos :',
    uploadMemory: 'Télécharge ton souvenir :',
    selectMemory: 'Sélectionnez un souvenir',
    taggedContacts: 'Contacts identifiés',
    contactTagged: 'Contact identifié :',
    contactsTagged: 'Contacts identifiés :',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    currently: 'Actuellement',
    cityOrCountryName: 'Nom de la ville ou pays',
    duration: 'Durée',
    currentlyLivingHere: 'Je vis actuellement dans ce lieu',
  },
  notesScreen: {
    title: 'Notes',
    sharedNote: 'Note partagée',
    personalNote: 'Note personnelle',
    shared: 'partagée',
    personal: 'perso',
  },
  scheduledMessagesScreen: {
    private: 'Privé',
    pro: 'Pro',
    groups: 'Groupes',
    categoriesTab: 'Catégories',
    title: 'Messages programmés',
    results: '{count} résultats',
    scheduledFor: 'Programmé pour {time}',
    editing: 'Modifiez le message ci-dessous',
    deleteConfirm: 'ce message programmé',
    createMessage: 'Créer un message',
    chooseRecipient: 'Choisir un destinataire',
    typeMessage: 'Écrire un message',
    deleteScheduledMessage: 'Supprimer le message programmé',
  },
  hashtagsScreen: {
    notFound: 'Hashtag non trouvé',
    newHashtag: 'Nouveau hashtag',
    person: '{count} personne',
    persons: '{count} personnes',
    results: '{count} résultat',
    resultsPlural: '{count} résultats',
  },
  relationalColorsScreen: {
    title: 'Couleurs relationnelles',
    notFound: 'Couleur associée non trouvée',
    person: '{count} personne',
    persons: '{count} personnes',
    results: '{count} résultat',
    resultsPlural: '{count} résultats',
  },
  categoriesScreen: {
    title: 'Catégories',
    addSubcategory: 'Ajouter une sous-catégorie',
    subcategoryPhoto: 'Photo de la sous-catégorie',
    subcategoryPlaceholder: 'Titre de la sous-catégorie...',
    categoryPhoto: 'Photo de la catégorie',
    newCategory: 'Nouvelle catégorie',
    categoryTitlePlaceholder: 'Titre de la catégorie...',
    addCategory: 'Ajouter une catégorie',
    addSubcategoryWithPhoto: 'Ajouter une sous-catégorie',
    person: '{count} personne',
    persons: '{count} personnes',
    backToList: 'Retour à la liste des catégories',
  },
  notificationsScreen: {
    toAddPeople: 'pour ajouter des personnes',
    acceptAsPro: 'Accepter en tant que pro',
    acceptAsPrivate: 'Accepter en tant que privé',
    accept: 'Accepter',
  },
  notifications: {
    friendRequest: 'Demande de contact',
    acceptedRequest: 'Demande acceptée',
    rejectedRequest: 'Demande refusée',
    upcomingEvent: 'Événement à venir',
    contactReminder: 'Rappel Keep in touch',
    scheduledMessage: 'Message programmé',
    birthday: 'Anniversaire',
    syncContacts: 'Synchroniser mes contacts',
    toAddPeople: 'Pour ajouter des personnes',
    all: 'Tout',
    requests: 'Demandes',
    agenda: 'Agenda',
    accept: 'Accepter',
    reject: 'Refuser',
    accepted: 'Accepté',
    rejected: 'Refusé',
    acceptAsPro: 'Accepter en tant que pro',
    acceptAsPrivate: 'Accepter en tant que privé',
    orRejectRequest: 'Ou refuser la demande',
    sections: {
      today: "Aujourd'hui",
      thisWeek: 'Cette semaine',
      earlier: 'Plus tôt',
    },
    empty: {
      title: 'Tout est à jour',
      subtitle: "Vous n'avez aucune notification pour le moment.",
    },
  },
  mapScreen: {
    title: 'Carte',
    contactFound: '{count} contact trouvé dans cette zone',
    contactsFound: '{count} contacts trouvés dans cette zone',
    contactsFoundInZone:
      '{count, plural, =0 {Aucun contact dans cette zone} one {{count} contact trouvé dans cette zone} other {{count} contacts trouvés dans cette zone}}',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    zoomLevel: 'Niveau de zoom',
  },
  birthdaysScreen: {
    title: 'Anniversaires',
    upcoming: 'Anniversaires à venir',
    private: 'Privé',
    pro: 'Pro',
    noBirthday: 'Aucun anniversaire',
  },
  keepContactScreen: {
    private: 'Privée',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Partager le profil',
    copyLink: 'Copier le lien',
    download: 'Télécharger',
  },
  webFooter: {
    legalNotice: 'Mentions légales',
    contactUs: 'Nous contacter',
    privacyPolicy: 'Charte de confidentialité',
    joinUs: 'Nous rejoindre',
  },
  legalNotice: {
    editor: 'Éditeur',
    editorContent:
      "KeepTouch SAS\nCapital social : 10 000 €\nSiège social : Paris, France\nNuméro d'immatriculation : RCS Paris\nDirecteur de la publication : Équipe KeepTouch",
    hosting: 'Hébergement',
    hostingContent:
      "L'application est hébergée par Amazon Web Services (AWS)\nAdresse : 38 Avenue John F. Kennedy, L-1855 Luxembourg",
    intellectualProperty: 'Propriété intellectuelle',
    intellectualPropertyContent:
      "L'ensemble du contenu de l'application KeepTouch (textes, images, logos, icônes, logiciels) est la propriété exclusive de KeepTouch SAS et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation ou diffusion sans autorisation écrite préalable est interdite.",
    liability: 'Responsabilité',
    liabilityContent:
      "KeepTouch SAS s'efforce de fournir des informations exactes et à jour. Toutefois, elle ne peut garantir l'exactitude, l'exhaustivité ou l'actualité des informations disponibles sur l'application. KeepTouch SAS ne saurait être tenue responsable de tout dommage direct ou indirect résultant de l'utilisation de l'application.",
  },
  contactUs: {
    description:
      "Vous avez une question, une suggestion ou besoin d'assistance ? N'hésitez pas à nous contacter. Notre équipe vous répondra dans les meilleurs délais.",
    emailLabel: 'Email',
    email: 'contact@keeptouch.app',
    addressLabel: 'Adresse',
    address: 'KeepTouch SAS\nParis, France',
  },
  privacyPolicy: {
    introduction:
      "KeepTouch s'engage à protéger la vie privée et les données personnelles de ses utilisateurs. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos informations.",
    dataCollection: 'Collecte des données',
    dataCollectionContent:
      "Nous collectons les données que vous fournissez volontairement lors de la création de votre compte et de l'utilisation de l'application : nom, adresse email, contacts, notes, rappels et toute autre information que vous choisissez de partager.",
    dataUsage: 'Utilisation des données',
    dataUsageContent:
      'Vos données sont utilisées exclusivement pour fournir et améliorer le service KeepTouch. Nous ne vendons ni ne partageons vos données personnelles avec des tiers à des fins marketing.',
    dataProtection: 'Protection des données',
    dataProtectionContent:
      'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès, modification, divulgation ou destruction non autorisés.',
    cookies: 'Cookies',
    cookiesContent:
      "L'application peut utiliser des cookies et technologies similaires pour améliorer l'expérience utilisateur et analyser l'utilisation. Vous pouvez gérer vos préférences en matière de cookies à tout moment depuis vos paramètres.",
    rights: 'Vos droits',
    rightsContent:
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données personnelles. Vous avez également le droit de limiter et de vous opposer au traitement de vos données. Pour exercer ces droits, contactez-nous à : contact@keeptouch.app",
  },
  joinUs: {
    description:
      'KeepTouch est une application innovante dédiée à aider les gens à maintenir et renforcer leurs relations. Rejoignez notre équipe et contribuez à un projet qui fait la différence !',
    whyJoin: 'Pourquoi rejoindre KeepTouch ?',
    whyJoinContent:
      '• Travailler sur un projet innovant à impact social\n• Rejoindre une équipe passionnée et dynamique\n• Environnement de travail flexible et télétravail possible\n• Opportunités de croissance et de développement',
    positions: 'Postes ouverts',
    positionsContent:
      'Nous sommes toujours à la recherche de talents pour rejoindre notre équipe. Les postes actuellement ouverts incluent :\n\n• Développeur Full-Stack (React Native / NestJS)\n• Designer UX/UI\n• Responsable Marketing & Growth\n• Community Manager',
    apply: 'Comment postuler',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Affection & Intimité',
      description: 'Ces contacts nourrissent ton cœur.',
    },
    'aspiration-inspiration': {
      name: 'Aspiration & Inspiration',
      description: 'Ces contacts te tirent vers le haut.',
    },
    'stimulation-aventure': {
      name: 'Stimulation & Aventure',
      description: 'Ces contacts mettent du mouvement et de la folie dans ta vie.',
    },
    'soutien-stabilite': {
      name: 'Soutien & Stabilité',
      description: 'Ces contacts te soutiennent émotionnellement et te structurent.',
    },
    'reflexion-profondeur': {
      name: 'Réflexion & Profondeur',
      description: "Ces contacts t'aident à penser, te comprendre, évoluer.",
    },
    'lacher-prise-detente': {
      name: 'Lâcher-prise & Détente',
      description: "Ces contacts t'aident à respirer, décrocher, exister sans pression.",
    },
    affection: 'Affection',
    'joie-chaleureuse': 'Joie chaleureuse',
    'tendre-complicite': 'Tendre complicité',
    'presence-reconfortante': 'Présence réconfortante',
    'partage-authentique': 'Partage authentique',
    aspiration: 'Aspiration',
    motivation: 'Motivation',
    source: 'Source',
    'elan-creatif': 'Élan créatif',
    'grandeur-ame': "Grandeur d'âme",
    stimulation: 'Stimulation',
    aventure: 'Aventure',
    exploration: 'Exploration',
    'adrenaline-partagee': 'Adrénaline partagée',
    fun: 'Fun',
    soutien: 'Soutien',
    encouragement: 'Encouragement',
    securite: 'Sécurité',
    apaisement: 'Apaisement',
    'croissance-lente': 'Croissance lente',
    apprentissage: 'Apprentissage',
    comprehension: 'Compréhension',
    miroir: 'Miroir',
    'conscience-soi': 'Conscience de soi',
    'conversations-vraies': 'Conversations vraies',
    detente: 'Détente',
    legerete: 'Légèreté',
    'presence-sans-enjeu': 'Présence sans enjeu',
    rire: 'Rire',
    instantaneite: 'Instantanéité',
  },
  meetingContexts: {
    'education-formation': 'Éducation et formation',
    educatif: 'Éducatif',
    formation: 'Formation',
    etude: 'Étude',
    'event-pro': 'Événement et professionnel',
    event: 'Événementiel',
    'event-pro-item': 'Événement professionnel',
    networking: 'Networking',
    'etude-client': 'Étude client',
    'sport-hobbies': 'Sport et loisirs',
    sportif: 'Sportif',
    loisir: 'Loisir',
    festival: 'Festival',
    artistique: 'Artistique',
    'voyage-discovery': 'Voyage et découverte',
    voyage: 'Voyage',
    naturel: 'Naturel',
    'relations-rencontres': 'Relations et rencontres',
    mariage: 'Mariage',
    'rencontre-sociale': 'Rencontre sociale',
    'rencontre-famille': 'Rencontre familiale',
    'rencontre-benevole': 'Rencontre bénévole',
    'famille-proche': 'Famille proche',
    'event-online': 'Événement en ligne',
    eventSpecific: 'Événement spécifique',
  },
  rrule: {
    custom: 'Personnalisée',
  },
  relationshipStatus: {
    growing: 'En croissance',
    stable: 'Stable',
    to_reconnect: 'À recontacter',
    fluctuating: 'Fluctuante',
    declining: 'En décroissance',
    ended: 'Terminé',
  },
  nearby: {
    headerTitle: 'À proximité',
    pageTitle: 'Contacts à proximité',
    perimeter10: 'Profils à moins de 10 km',
    perimeter50: 'Profils à moins de 50 km',
    perimeter100: 'Profils à moins de 100 km',
    perimeter10Short: 'À moins de 10 km',
    perimeter50Short: 'À moins de 50 km',
    perimeter100Short: 'À moins de 100 km',
    perimeterLabel: 'Périmètres',
    visibilityAll: 'Vous êtes actuellement visible pour tous les utilisateurs.',
    visibilityProfessional: 'Vous êtes actuellement visible pour vos relations professionnelles.',
    visibilityPrivate: 'Vous êtes actuellement visible pour vos relations privées.',
    visibilityHidden: "Vous n'êtes actuellement visible pour personne à proximité.",
    visibilityAllMobile: 'Visible pour tous les utilisateurs.',
    visibilityProfessionalMobile: 'Visible pour vos relations professionnelles.',
    visibilityPrivateMobile: 'Visible pour vos relations privées.',
    visibilityHiddenMobile: 'Visible pour personne.',
    visibilityLoading: 'Chargement de votre visibilité...',
    editVisibility: 'Modifier ma visibilité',
    filterPrivate: 'Privé',
    filterPro: 'Pro',
    emptyNoResults: 'Aucun résultat.',
    emptyNoContacts: 'Aucun contact trouvé à proximité.',
    groupLabel: 'Les profils à moins de {distance} km !',
    visibilityOptionAllTitle: 'Pro & Privé',
    visibilityOptionAllDescription:
      'Votre profil est visible par tous les utilisateurs (professionnels et privés).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible uniquement par les professionnels et entreprises.',
    visibilityOptionPrivateTitle: 'Privé',
    visibilityOptionPrivateDescription: 'Visible uniquement par les utilisateurs privés.',
    visibilityOptionHiddenTitle: 'Ne pas être visible',
    visibilityOptionHiddenDescription: "Votre profil n'apparaît pour personne à proximité.",
    modalTitle: 'Modifier ma visibilité',
    modalSubtitle: 'Choisissez qui peut voir votre profil sur KeepTouch',
    modalHint: 'Cochez une ou plusieurs options selon vos besoins.',
    updateButton: 'Mettre à jour la visibilité',
    scopePrivate: 'Privé',
    scopePro: 'Pro',
  },
  ai: {
    assistant: 'Assistant IA',
    tabSuggest: 'Suggérer',
    tabSummarize: 'Résumer',
    tabAnalyze: 'Analyser',
    generateSuggestions: 'Générer des suggestions',
    use: 'Utiliser',
    summaryInProgress: 'Résumé en cours...',
    analysisInProgress: 'Analyse en cours...',
    sentiment: 'Sentiment',
    sentimentUndetermined: 'Non déterminé',
    topics: 'Sujets abordés',
    dynamics: 'Dynamique',
    keyPoints: 'Points clés',
    errorRetry: 'Une erreur est survenue. Réessayez.',
    instructionsPlaceholder: "Instructions (optionnel) : ex. 'ton formel', 'propose un rdv'...",
    generatedByAi: "Message généré par l'IA",
  },
  scheduledMessage: {
    create: {
      reasonQuestion: 'Quelle est la raison du message ?',
      writeManually: 'Écrire moi-même',
      recipientBadge: 'Pour',
      reasonBadge: 'Raison',
      additionalDetailsPlaceholder: 'Ex: Il vient de décrocher un nouveau poste...',
      messageForContact: 'Message pour {name}',
      additionalDetails: 'Détails supplémentaires (optionnel)',
      scheduledFor: '{date} à {time}',
    },
    schedule: {
      programButton: 'Programmer',
    },
  },
  cardScan: {
    awaitingCamera: 'En attente de la caméra...',
    allowCamera: 'Autoriser la caméra',
    retake: 'Reprendre',
    analyze: 'Analyser',
    dragDropPhoto: 'Glissez-déposez une photo de carte de visite ici',
    orClickToSelect: 'ou cliquez pour sélectionner un fichier',
  },
  qrCodeScan: {
    title: 'Scanner un Code QR',
    headerTitle: 'QR Code',
  },
  ghostForm: {
    tagsSection: 'Tags',
    pinsSection: 'Pins',
    organizeProfile: 'Ranger le profil',
    hashtagPlaceholder: 'Nom du #...',
    goalPlaceholder: 'Construire une maison...',
    profileHashtagsName: 'Hashtag du profile',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'Aucune note "partagée"',
      titlePersonal: 'Aucune note "perso"',
      pressPlusToCreate: 'Appuyez sur + pour créer votre première note',
    },
  },
  editCategory: {
    title: 'Modifier une catégorie',
    deleteConfirm: 'cette catégorie',
  },
  editHashtag: {
    deleteConfirm: 'ce hashtag',
  },
  editNote: {
    deleteConfirm: 'cette note',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Amis en commun',
    inContactWith: 'En contact avec {names}',
  },
  formExtra: {
    selectTime: 'Sélectionner une heure',
    yourMessage: 'Votre message...',
    chooseTime: "Choisir l'heure",
    cancel: 'Annuler',
  },
  filterHeader: {
    clear: 'Effacer',
  },
  messagesPinned: {
    label: 'Épinglés',
  },
  translate: {
    toggle: 'Traduire',
    original: 'Texte original',
    lang: {
      fr: 'Français',
      en: 'Anglais',
      es: 'Espagnol',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Fantôme',
    realBadge: 'Contact réel',
    reason: {
      FullName: 'Nom complet identique',
      LastName: 'Nom de famille identique',
      FirstName: 'Prénom identique',
      Email: 'Email identique',
      Phone: 'Téléphone identique',
      LinkedIn: 'LinkedIn identique',
      Instagram: 'Instagram identique',
      Facebook: 'Facebook identique',
      Twitter: 'Twitter identique',
    },
  },
  ftSocialImport: {
    title: 'Importer depuis un réseau social',
    chooseNetwork: 'Choisissez un réseau social',
    usernameLabel: "Nom d'utilisateur",
    linkedinNameLabel: 'Nom de la personne',
    startImport: "Lancer l'import",
    placeholder: {
      linkedin: 'Prénom Nom (ex: Jean Dupont)',
      facebook: 'URL ou username (ex: https://facebook.com/zuck)',
      twitter: 'URL ou username (ex: https://x.com/elonmusk)',
      instagram: "Nom d'utilisateur (ex: ethpas)",
      generic: "Nom d'utilisateur",
    },
    launched: {
      title: 'Import lancé',
      message:
        "L'import a été lancé. Vous pouvez suivre sa progression depuis la liste de contacts.",
      networkMessage: "L'import {network} a été lancé.",
    },
    error: {
      title: 'Erreur',
      startFailed: "Impossible de lancer l'import",
      validateFailed: 'Impossible de valider la sélection',
      genericError: 'Une erreur est survenue',
    },
    previousImports: 'Imports précédents',
    newImport: 'Nouvel import',
    inProgress: 'Import en cours…',
    failed: 'Échoué',
    alreadyAdded: 'Déjà ajouté',
    profilesFound: '{count, plural, one {# profil trouvé} other {# profils trouvés}}',
    networkDescription: {
      linkedin: 'Entrez le nom de la personne à recherchez',
      generic: 'Entrez le username {network} pour importer ses followers',
    },
    results: {
      title: 'Résultats — {network}',
      runningHint: 'Cela peut prendre quelques minutes',
      failedTitle: "L'import a échoué",
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      validate: 'Valider la sélection ({count})',
      successTitle: 'Succès',
      successMessage: '{count, plural, one {# profil importé} other {# profils importés}}',
    },
  },
} as const
